/**
 * The default aspect ratio tu use.
 */
export const DEFAULT_ASPECT_RATIO = 3 / 2;

/**
 * The default focal point position (center).
 */
export const CENTER_FOCAL_POINT = { x: 0, y: 0 };
